import AccordionText from "@/components/AccordionTextRefresh";
import AccordionTextItem from "@/components/AccordionTextRefresh/AccordionTextItemRefresh";
import { ProgramFAQsProps } from "./types";
import parse from "html-react-parser";
import useTranslations from "@/i18n/useTranslations";

export default function ProgramFAQs({ faqs }: ProgramFAQsProps) {
  const t = useTranslations("Program");
  if (!faqs?.length) return null;

  const sortedFaqs = [...faqs].sort((a, b) => {
    const valueA = a.sortValue ?? Infinity;
    const valueB = b.sortValue ?? Infinity;
    return valueA - valueB;
  });

  const validFaqs = sortedFaqs.filter(
    (faq) => faq.question !== null && faq.answer !== null,
  );

  if (!validFaqs.length) return null;

  const transformedFaqs = validFaqs.map((faq) => (
    <AccordionTextItem key={faq.question} trigger={faq.question || ""}>
      <div className="prose" style={{ wordBreak: "keep-all" }}>
        {typeof faq.answer === "string" ? parse(faq.answer) : faq.answer}
      </div>
    </AccordionTextItem>
  ));

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-6">
        <h2 className="my-0 md:text-3xl">{t("frequentlyAskedQuestions")}</h2>
        <AccordionText>{transformedFaqs}</AccordionText>
      </div>
    </div>
  );
}
